import { Injectable, inject } from "@angular/core";
import { ToastState } from "./ToastState";
import { ToastItem, ToastVariant } from "../Dto/ToastModel";

const MAX_TOASTS = 3;
const DEFAULT_DURATION_MS = 4000;

@Injectable({ providedIn: "root" })
export class ToastEffects {
  private readonly toastState = inject(ToastState);
  private readonly timers = new Map<string, ReturnType<typeof setTimeout>>();
  private counter = 0;

  show(message: string, variant: ToastVariant = "info", durationMs = DEFAULT_DURATION_MS): void {
    const id = this.createId();
    const toast: ToastItem = { id, message, variant, durationMs };

    const current = this.toastState.data();
    const next = [toast, ...current];
    if (next.length > MAX_TOASTS) {
      const overflow = next.slice(MAX_TOASTS);
      overflow.forEach((item) => this.clearTimer(item.id));
    }

    this.toastState.setToasts(next.slice(0, MAX_TOASTS));

    const timer = setTimeout(() => this.dismiss(id), durationMs);
    this.timers.set(id, timer);
  }

  dismiss(id: string): void {
    this.toastState.removeToast(id);
    this.clearTimer(id);
  }

  private createId(): string {
    this.counter += 1;
    return `toast-${this.counter}`;
  }

  private clearTimer(id: string): void {
    const timer = this.timers.get(id);
    if (timer) {
      clearTimeout(timer);
      this.timers.delete(id);
    }
  }
}
